/**
 * FileUploadRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { FileInfo } from './file_info'

/**
 * FileUploadRes
 */
export interface FileUploadRes {
  /** 文件信息 */
  file?: FileInfo
}

/**
 * FileUploadRes Schema
 */
export const FileUploadResSchema: SchemaDefinition = {
  properties: {
    file: {
      $ref: 'FileInfo',
      description: '文件信息',
      label: '文件信息',
    },
  },
  type: 'object',
}
